/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsEvidenceExportGipAltReportMutationRequest, AuditReportsEvidenceExportGipAltReportMutationResponse, AuditReportsEvidenceExportGipAltReportPathParams, AuditReportsEvidenceExportGipAltReport400, AuditReportsEvidenceExportGipAltReport401, AuditReportsEvidenceExportGipAltReport403, AuditReportsEvidenceExportGipAltReport404 } from "../models/AuditReportsEvidenceExportGipAltReport";

export function getAuditReportsEvidenceExportGipAltReportUrl(id: AuditReportsEvidenceExportGipAltReportPathParams["id"]) {
  const res = { method: 'POST', url: `/audit-reports/v1/reports/gip-alt/report/${id}/evidence-export` as const }
  return res
}

/**
 * @summary Start evidence export
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/evidence-export}
 */
export async function auditReportsEvidenceExportGipAltReport(id: AuditReportsEvidenceExportGipAltReportPathParams["id"], data: AuditReportsEvidenceExportGipAltReportMutationRequest, config: Partial<RequestConfig<AuditReportsEvidenceExportGipAltReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsEvidenceExportGipAltReportMutationResponse, ResponseErrorConfig<AuditReportsEvidenceExportGipAltReport400 | AuditReportsEvidenceExportGipAltReport401 | AuditReportsEvidenceExportGipAltReport403 | AuditReportsEvidenceExportGipAltReport404>, AuditReportsEvidenceExportGipAltReportMutationRequest>({ method : "POST", url : getAuditReportsEvidenceExportGipAltReportUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}